import CharacterLimitController from "scripts/marmalade/classes/character-limits";
const CharacterLimitWatcher = new Watcher();
CharacterLimitWatcher.on('update', elements => {
  elements.forEach(element => {
    new CharacterLimitController(element);
  });
});
CharacterLimitWatcher.watch('[maxlength]');